import { atom } from "jotai";
import type { VendorResponse } from "@models/vendor";

export const vendorsAtom = atom<VendorResponse[]>([]);
export const isFetchingVendorsAtom = atom<boolean>(false);
export const isProcessingVendorsAtom = atom<boolean>(false);
